"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MindActivationWorkflowButton = void 0;
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const activities_1 = require("../../../api/activities");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const ScopeGuard_1 = __importDefault(require("../../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const LicenseState_1 = require("../../../common/js/enums/LicenseState");
const license_1 = require("../../../common/js/helper/license");
const translation_1 = require("../../../common/js/helper/translation");
const LockType_1 = __importDefault(require("../../enums/LockType"));
const product_1 = require("../../helper/product");
const useLicenseState_1 = require("../../hooks/useLicenseState");
const Activities_1 = __importDefault(require("../../stores/Activities"));
const LicenseStore_1 = __importDefault(require("../../stores/LicenseStore"));
const GenericLicenseActivationWorkflowButton_1 = require("./GenericLicenseActivationWorkflowButton");
exports.MindActivationWorkflowButton = (0, mobx_react_1.observer)(({ license }) => {
    const isHardlock = license.lockType === LockType_1.default.HARDLOCK;
    const hasLicenseFile = !!license.fileName;
    const { state, isFetching } = (0, useLicenseState_1.useLicenseState)(license);
    if (isHardlock && hasLicenseFile) {
        return (react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.LICENSE_DOWNLOAD] },
            react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.secondary, text: (0, translation_1.t)('myassets.software.btn.download_license.title'), loading: LicenseStore_1.default.isDownloading || isFetching, disabled: LicenseStore_1.default.isDownloading || state !== LicenseState_1.LicenseState.ConsentGiven, onClick: () => {
                    Activities_1.default.save((0, license_1.licenseActivity)(activities_1.ActivityTopic.ConsentDownloadLicense, license));
                    (0, product_1.downloadLicenses)(license.id);
                } })));
    }
    return react_1.default.createElement(GenericLicenseActivationWorkflowButton_1.GenericLicenseActivationWorkflowButton, { license: license });
});
